const state = () => ({
  currency: 2,
})
export default state
